Ext.ns('mx.comp');

mx.comp.FieldGroup = Ext.extend(Ext.form.CheckboxGroup, {
    itemCls: 'mx-comp-fieldgroup-form-item',
    isFieldContainer: true,

    destroy: function() {
        Ext.destroy.apply(this, this.items.items);
    },

    //Для обхода вложенных компонентов методом find
    cascade: Ext.Container.prototype.cascade,
});

Ext.reg('mx_fieldgroup', mx.comp.FieldGroup);
